import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, StudyPlanTargets, Transitions } from "../types"
import { setRedirectUrl } from "../actions/setRedirectUrl"
import { setSPV2RedirectUrl } from "../studyPlanV2/actions"
import { BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH } from "../studyPlanV2/constants"

export const getRecommendedPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getRecommendedPlan",
    src: "getRecommendedPlan",
    onDone: [
      {
        target: "#StudyPlan.review_plan",
        actions: [
          assign((ctx, evt, meta) => {
            if (ctx.previousParentState === "landing_view") {
              return {}
            }

            return ctx.isStudyPlanV2Enabled
              ? setSPV2RedirectUrl(
                  ctx,
                  evt,
                  null,
                  StudyPlanTargets.ViewRecommended
                )
              : setRedirectUrl(ctx, evt, meta, StudyPlanTargets.ViewRecommended)
          }),
          assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => ({
            // REVIEW: would be better to save separately, in "recommendedPlan"?
            currentTarget: StudyPlanTargets.ViewRecommended,
            recommendedStudyPlan: evt.data?.plan
          }))
        ]
      }
    ],
    onError: [
      {
        target: `${BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH}.idle`,
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, _evt) => ({
            message: getServiceErrorMessage("getRecommendedPlan", {
              messageData: ["get recommended study plan"]
            }),
            withUndo: false,
            error: true
          })
        }),
        cond: ctx =>
          ctx.isStudyPlanV2Enabled &&
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL")
      },
      {
        target: "#StudyPlan.review_plan",
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, _evt) => ({
            message: getServiceErrorMessage("getRecommendedPlan", {
              messageData: ["get recommended study plan"]
            }),
            withUndo: false,
            error: true
          })
        })
      }
    ]
  }
}
